import { Button, Table } from "react-bootstrap";
import { addPickToEntry, removePickFromEntry, retrieveMyEntries, retrieveUser, retrieveWeeks, submitEntry } from "../../api/api";

export function UnsubmittedEntry(props) {

    if (!props.games || props.games.length === 0 || !props.entry) {
        return <></>
    }

    const getGamesByDate = () => {
        let gamesByDate = {};
        props.games.filter((g) => { return Date.now() < Date.parse(g.start_time) && !g.start_time_tbd && g.home_spread !== undefined }).forEach((g) => {
            const dateString = new Date(Date.parse(g.start_time)).toLocaleDateString("en-US", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
            if (!gamesByDate[dateString]) {
                gamesByDate[dateString] = [];
            }
            gamesByDate[dateString].push(g);
        });
        return gamesByDate;
    };

    const getFavoriteText = (game) => {
        if (game.home_spread <= 0) {
            return `${(game.neutral_site ? '' : '@')} ${game.home_team} ${game.home_spread}`
        }
        return `${game.away_team} ${-game.home_spread}`
    }

    const getUnderdogText = (game) => {
        if (game.home_spread > 0) {
            return `${(game.neutral_site ? '' : '@')} ${game.home_team} ${game.home_spread}`
        }
        return `${game.away_team} ${-game.home_spread}`
    }

    const isHomeFavorite = (game) => {
        return game.home_spread <= 0;
    }

    const isPicked = (game, favorite) => {
        const homeFavorite = isHomeFavorite(game);
        for (let i = 0; i < props.entry.picks.length; i++) {
            const p = props.entry.picks[i];
            if (p.game_id === game.id) {
                if (p.home_team) {
                    return favorite ? homeFavorite : !homeFavorite;
                } else {
                    return favorite ? !homeFavorite : homeFavorite;
                }
            }
        }
        return false;
    };

    const handlePickClick = (event, game, favorite) => {
        const homeFavorite = isHomeFavorite(game);
        let action = isPicked(game, favorite) ? removePickFromEntry(game, props.entry) : addPickToEntry(homeFavorite === favorite, game, props.entry);
        action.then((entry) => {
            props.setEntry(entry);
        }).finally(() => {
            event.target.blur();
        });
    }

    const handleSubmitClick = () => {
        submitEntry(props.entry).then((e) => {
            retrieveUser().then((u) => {
                props.setUser(u);
            });
            retrieveMyEntries(props.week.number).then((entries) => {
                props.setEntries(entries);
                props.setEntry(null);
            });
            retrieveWeeks().then((weeks) => {
                props.setWeeks(weeks);
            });
        });
    }

    const notPassedDeadline = () => {
        return Date.now() < Date.parse(props.week.deadline);
    }

    return (
        <div className="row">
            <div className="column">
                <h2 className="py-4">{props.entry.name}{notPassedDeadline() && <Button className="ms-3" onClick={handleSubmitClick}>Submit</Button>}</h2>
                {Object.entries(getGamesByDate()).map(([date, games]) => {
                    return (
                        <Table key={props.entry.id + '-' + date} borderless variant="dark" className="w-auto transparent">
                            <tbody>
                                <tr>
                                    <td colSpan={3} className="text-center"><span className="h4">{date}</span><br /><br /></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td className="text-center"><strong>Favorite</strong></td>
                                    <td className="text-center"><strong>Underdog</strong></td>
                                </tr>
                                {games.map((g) => {
                                    return (<tr key={g.id}>
                                        <td>{new Date(Date.parse(g.start_time)).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', timeZoneName: 'short' })}</td>
                                        <td><Button variant={isPicked(g, true) ? "primary" : "outline-primary"} className="w-100" onClick={(e) => { handlePickClick(e, g, true) }}>{getFavoriteText(g)}</Button></td>
                                        <td><Button variant={isPicked(g, false) ? "primary" : "outline-primary"} className="w-100" onClick={(e) => { handlePickClick(e, g, false) }}>{getUnderdogText(g)}</Button></td>
                                    </tr>);
                                })}
                            </tbody>
                        </Table>
                    );
                })}
            </div>
        </div>
    );
}